'use strict';

const _=require('pulsar-utils/dist-es6/_');let

ControllerExtensions=class ControllerExtensions{
constructor(controller){
this._controller=controller;
}

getMultiViewConfigurationFor(controllerPropertiesToBindToSubViews,multiViewConfigurations){
const sharedSubViewBindings=_.transform(
controllerPropertiesToBindToSubViews,
(result,value,key)=>result[_.kebabCase(value)]=`controller.${value}`);


return multiViewConfigurations.map(config=>Object.assign({bindings:sharedSubViewBindings},config));
}

static extend(controller){
return new ControllerExtensions(controller);
}};


module.exports=ControllerExtensions.extend;
//# sourceMappingURL=controllerExtensions.js.map
